const setContent = (type, data) => {
    return {
        type: type,
        data: data
    }
}

export default setContent;